export const POSTING_PREFERENCE_ENABLED_OPTION_LABEL = 'posting-preference.enabled-option-label';
export const POSTING_PREFERENCE_DISABLED_OPTION_LABEL = 'posting-preference.disabled-option-label';
